<template>
  <div class="divider-wrap">
    <!-- <el-divider class="divider-main"> -->
    <!-- <div class="lineLeft line"></div>
    <div class="lineRight line"></div> -->
    <div class="divider">
      <div class="chinese" :style="{ 'color': color }">
        <p class="lineLeft line"></p>
        <p class="text">{{ chinese }}</p>
        <p class="lineRight line"></p>
      </div>
      <div class="english">{{ english }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chinese: {
      type: String,
      default: ''
    },
    english: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#333'
    }
  }
};
</script>

<style lang="scss" scoped>
.divider-wrap {
  padding: 10px 0 30px;
}

.line {
  width: 300px;
  height: 2px;
}

.lineLeft {
  background: -webkit-linear-gradient(to right, RGBA(65, 189, 96, .1), RGBA(65, 189, 96, .5), RGBA(65, 189, 96, 1));
  background: -moz-linear-gradient(to right, RGBA(65, 189, 96, .1), RGBA(65, 189, 96, .5), RGBA(65, 189, 96, 1));
  background: linear-gradient(to right, RGBA(65, 189, 96, .1), RGBA(65, 189, 96, .5), RGBA(65, 189, 96, 1));
}

.lineRight {
  background: -webkit-linear-gradient(to left, RGBA(65, 189, 96, .1), RGBA(65, 189, 96, .5), RGBA(65, 189, 96, 1));
  background: -moz-linear-gradient(to left, RGBA(65, 189, 96, .1), RGBA(65, 189, 96, .5), RGBA(65, 189, 96, 1));
  background: linear-gradient(to left, RGBA(65, 189, 96, .1), RGBA(65, 189, 96, .5), RGBA(65, 189, 96, 1));
}

.divider-main {
  background-color: #bfdbf3 !important;
  height: 2px !important;
}

.divider {
  color: $el-main-color;
  text-align: center;
  // width: 310px;
  margin: 0 auto;

  .chinese {
    font-size: 30px;
    color: #333;
    // position:relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .text {
      padding: 0 74px;
    }
  }

  .english {
    font-size: 30px;
    color: rgba(51, 51, 51, .3);
    font-family: Source Han Sans CN;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/divider.vue